import { render } from "./lead-stages.vue?vue&type=template&id=e04a481c"
import script from "./lead-stages.vue?vue&type=script&lang=js"
export * from "./lead-stages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__